import type { BcField, BcFieldData } from '../types';
import { BC_DEFAULT_PROCESS } from './bcDefaultProcess';
import { BC_FIELDS } from './bcFields';

export const BC_FIELD_MAPPINGS = {
  [BC_FIELDS.AMS]: {
    name: 'AMS',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.ASM_CUT]: {
    name: 'ASM Cut',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.ASTM]: {
    name: 'ASTM',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.BAR_END_TO_BAR_END]: {
    name: 'Bar End To Bar End',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.CDA]: {
    name: 'CDA',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.CHAMFER_BAR_END]: {
    name: 'Chamfer-Bar-End',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.CHAMFER_BAR_END_COMMENTS]: {
    name: 'Chamfer Bar End Comments',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.CUSTOMER_REQUESTED_UOM]: {
    name: 'Customer Requested UoM',
    type: 'string',
    default: 'None',
  },
  [BC_FIELDS.DFARS]: {
    name: 'DFARS',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.DISTRIBUTION_CENTER]: {
    name: 'Dist. Center',
    type: 'string',
    default: 'No DC',
  },
  [BC_FIELDS.INNER_DIAMETER]: {
    name: "Mat'l Inner Diameter",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.INNER_DIAMETER_TOLERANCE]: {
    name: "Mat'l Inner Diameter Tolerance",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.LAP_SELECTION]: {
    name: 'Lap Selection',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.LAPPING]: {
    name: 'Lapping',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.LASER_MARKING]: {
    name: 'Laser Marking',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.LASER_MARKING_COMMENTS]: {
    name: 'Laser Marking Comments',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.MATERIAL_HARDNESS]: {
    name: "Mat'l Hardness",
    type: 'string',
    default: '',
  },
  [BC_FIELDS.MATERIAL_LENGTH]: {
    name: 'Length',
    type: 'number',
    default: 144,
  },
  [BC_FIELDS.MATERIAL_LENGTH_TOLERANCE]: {
    name: "Mat'l Length Tolerance",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_LENGTH_TOLERANCE_OPTION]: {
    name: "Mat'l Length Tolerance Option",
    type: 'string',
    default: '+/-',
  },
  [BC_FIELDS.MATERIAL_ROUNDNESS]: {
    name: 'Roundness',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_SIZE]: {
    name: "Mat'l Size",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_SOURCE]: {
    name: 'Source',
    type: 'string',
    default: 'M',
  },
  [BC_FIELDS.MATERIAL_STRAIGHTNESS]: {
    name: 'Straightness',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_STRAIGHTNESS_UOM]: {
    name: 'Straightness UoM',
    type: 'string',
    default: 'FT',
  },
  [BC_FIELDS.MATERIAL_SURFACE_FINISH]: {
    name: 'Surface Finish',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_SURFACE_FINISH_UOM]: {
    name: 'S.F. UoM',
    type: 'string',
    default: 'Ra',
  },
  [BC_FIELDS.MATERIAL_WALL_THICKNESS]: {
    name: 'Wall Thickness',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_THICKNESS]: {
    name: "Mat'l Thickness",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_THICKNESS_TOLERANCE]: {
    name: "Mat'l Thickness Tolerance",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_WIDTH]: {
    name: "Mat'l Width",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MATERIAL_WIDTH_TOLERANCE]: {
    name: "Mat'l Width Tolerance",
    type: 'number',
    default: '',
  },
  [BC_FIELDS.MIL]: {
    name: 'MIL',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.MVC]: {
    name: 'MVC',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.MVC_SELECTION]: {
    name: 'MVC Selection',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.NUMBER_OF_MANUFACTURING_LOTS]: {
    name: '# of Mfg. Lots',
    type: 'number',
    default: 1,
  },
  [BC_FIELDS.NUMBER_OF_RELEASES]: {
    name: '# of Releases',
    type: 'number',
    default: 1,
  },
  [BC_FIELDS.OUR_TRUCK]: {
    name: 'Our Truck',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OUTER_DIAMETER]: {
    name: 'Outer Diameter',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.OUTER_DIAMETER_TOLERANCE]: {
    name: 'Outer Diameter Tolerance',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.PACK_MESH]: {
    name: 'Pack-Mesh',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.PACK_SLEEVE]: {
    name: 'Pack-Sleeve',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.PACK_SPECIAL]: {
    name: 'Pack-Special',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.PACK_TUBE]: {
    name: 'Pack-Tube',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.PART_UOM]: {
    name: 'Part UoM',
    type: 'string',
    default: 'FT',
  },
  [BC_FIELDS.PC_IS_BOUGHT]: {
    name: 'PC is bought',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.PPAP_INSPECTION_REQUIRED]: {
    name: "PPAP Inspection Req'd",
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.PROCESS_NAME]: {
    name: 'Process Name',
    type: 'string',
    default: BC_DEFAULT_PROCESS,
  },
  [BC_FIELDS.PRODUCT_SHAPE]: {
    name: 'Product Shape',
    type: 'string',
    default: 'RD',
  },
  [BC_FIELDS.QQ]: {
    name: 'QQ',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.ROHS]: {
    name: 'RoHS',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.SAW_CUT]: {
    name: 'Saw Cut',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.SPECIAL_MATERIAL_SPECS_OR_PROPERTIES]: {
    name: "Special Mat'l Specs/Properties",
    type: 'string',
    default: '',
  },
  [BC_FIELDS.STARTING_DIAMETER]: {
    name: 'Starting Diameter',
    type: 'number',
    default: '',
  },
  [BC_FIELDS.XRF_MANUAL]: {
    name: 'XRF-Manual',
    type: 'boolean',
    default: false,
  },

  [BC_FIELDS.OV_GUN_DRILL]: {
    name: 'OV Gun Drill',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_CUT]: {
    name: 'OV Cut',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_TESTING]: {
    name: 'OV Testing',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_DRAW]: {
    name: 'OV Draw',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_DRAW_STR_CUT]: {
    name: 'OV Draw, Str, Cut',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_STR_CUT]: {
    name: 'OV Str & Cut',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_GRIND]: {
    name: 'OV Grind',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_ULTRASONIC_TESTING]: {
    name: 'OV UltraSonic Testing',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_SURFACE_GRIND]: {
    name: 'OV Surface Grind',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_LAP]: {
    name: 'OV Lap',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_STRAIGHTEN]: {
    name: 'OV Straighten',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_PASSIVATE]: {
    name: 'OV Passivate',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_PLATE]: {
    name: 'OV Plate',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_CLEAN]: {
    name: 'OV Clean',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_CRYOGENIC]: {
    name: 'OV Cryogenic',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_TURN]: {
    name: 'OV Turn',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_HEAT_TREAT]: {
    name: 'OV Heat Treat',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_HEAT_TREAT_SPECIAL]: {
    name: 'OV Heat Treat Special',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.OV_HEAT_TREAT_SPECIAL_COMMENTS]: {
    name: 'OV Heat Treat Special Comments',
    type: 'string',
    default: '',
  },
  [BC_FIELDS.QA_TEST_INSTRON]: {
    name: 'QA Test Instron',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.QA_TEST_HARD]: {
    name: 'QA Test Hard',
    type: 'boolean',
    default: false,
  },
  [BC_FIELDS.QA_TEST_HARD_MIC]: {
    name: 'QA Test Hard Mic',
    type: 'boolean',
    default: false,
  },
} as const;

// Using variable with type annotation as substitute for satisfies keywork (not
// yet available in version of TypeScript we are using).
/* eslint-disable @typescript-eslint/no-unused-vars */
const typeCheck: Record<BcField, BcFieldData> = BC_FIELD_MAPPINGS;
/* eslint-enable @typescript-eslint/no-unused-vars */
